import React, { Component } from 'react';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import LOOKUP from 'constants/lookup';
import { Link } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import GeneralInfo from './GeneralInfo';
import PaymentInfo from './PaymentInfo';
import Socialmedia from './Socialmedia';

class GeneralInfoPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: "",
            value: 'a'
        };
    }

    // Change the tab 
    handleChange = (value) => {
        this.setState({
            value: value
        });
    };

    render() {
        const countries = LOOKUP.common.country.options || null;
        if (!countries) return null;

        const currency = LOOKUP.common.currency || null;
        if (!currency) return null;

        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active">{LOOKUP.menu.admin.generalInfo.text}</li>
                </ol>
                <h2>{LOOKUP.menu.admin.generalInfo.text}</h2>
            </div>
        );

        return (
            <ContainerDivided headerContent={header}>
                <Tabs
                    value={this.state.value}
                    onChange={this.handleChange}
                >
                    <Tab label="General" value="a">
                        <GeneralInfo />
                    </Tab>
                    <Tab label="Payment" value="b">
                        <PaymentInfo />
                    </Tab>
                    <Tab label="Socialmedia" value="c">
                        <Socialmedia />
                    </Tab>
                </Tabs>
            </ContainerDivided>
        );
    }
}

export default GeneralInfoPage;